/** The Profile page URL for profile `id`; `/profile` alone shows your own. */
export function profilePath(id: number | string): string {
  return `/profile?userId=${id}`;
}
